// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1___8018a5a7952c73eef85","cls2":"UserCard-cls2__c1f695b7ea580437f749 UserCard-cls1___8018a5a7952c73eef85","small":"UserCard-small__cfca5b4e75d0b7a8aa29"};